module.exports = ".fincol {\n  border: 1px solid;\n  border-radius: 5px;\n  margin-top: 1em;\n}\n\n.fincol img {\n  width: 350px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/top-games/top-games.component.css
// module id = ./src/app/components/top-games/top-games.component.css
// module chunks = main